import { getNow } from "DateExtensions";
import { type TimeInfo } from "LocaleSettings";
import { DefaultTimeFormatter, type TimeFormatter as wtgMaterialTimeFormatter } from "wtg-material-ui";

export default class TimeFormatter implements wtgMaterialTimeFormatter {
  private internalTimeFormatter: DefaultTimeFormatter;
  private timeInfo: TimeInfo;

  constructor(timeInfo: TimeInfo, languageCode: string) {
    /*! StartNoStringValidationRegion No captions here. */
    this.internalTimeFormatter = new DefaultTimeFormatter(languageCode, {
      name: "customtime",
      dateFormat: "",
      timeFormat: "24hr",
      firstDayOfWeek: 0,
      decimalCharacter: "",
      digitGroupSeparator: "",
      digitalGroupSpacing: "2",
    });
    /*! EndNoStringValidationRegion */

    this.timeInfo = timeInfo;
  }

  private getTimeZone(): string {
    return this.timeInfo.defaultTimeZone ?? "";
  }

  parse(displayTime: string, useSeconds: boolean): string | null {
    return this.internalTimeFormatter.parse(displayTime, useSeconds);
  }

  format(time: string, useSeconds: boolean): string {
    return this.internalTimeFormatter.format(time, useSeconds);
  }

  now(useSeconds: boolean): string {
    const valueFormatHHMM = "HH:mm";
    const valueFormatHHMMSS = "HH:mm:ss";
    const timeZoneNowValue = getNow(this.getTimeZone());
    return timeZoneNowValue.format(useSeconds ? valueFormatHHMMSS : valueFormatHHMM);
  }

  isValid(time: string): boolean {
    return this.internalTimeFormatter.isValid(time);
  }
}
